import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_resource_link = _resolveComponent("resource-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(_toDisplayString(_ctx.aliasForKey(_ctx.field.key, _ctx.keyMapper)) + " ", 1),
    _createVNode(_component_resource_link, { resource: _ctx.field }, null, 8, ["resource"])
  ]))
}